import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { colors } from 'config/theme';

export const Container = styled.span`
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
`;
export const Part = styled.span`
  color: ${colors.black};
`;
export const PartLink = styled(Link)`
  color: #2980b9;
  text-decoration: none;
`;
export const PartDivider = styled.span`
  display: inline-block;
  padding: 0px 6px;
  color: ${colors.darkGray};
  font-size: 18px;
`;
